import React, { useEffect, useState } from 'react'
import { Layout, Flex, Menu, Image, Button } from 'antd';
import MyHeaderOne from '../header';
import MyFooter from '../footer';
import style from './page.module.less'
import img from '../../img/bz.png'
import axios from 'axios';
import { REQUEST_URL } from '../../utils/env';
import { useSearchParams } from 'react-router-dom';

const { Header, Footer, Content } = Layout;

export default function Jckb() {

    const [searchParams, setSearchParams] = useSearchParams();
    const urlYear = searchParams.get('year');
    const urlIssue = searchParams.get('issue')



    const [issueItem, setIssueItem] = useState([])
    const [infoData, setInfoData] = useState([])
    const [total, setTotal] = useState(0)
    const [issueInfo, setIssueInfo] = useState()

    const [defaultSelectedKeys, setDefaultSelectedKeys] = useState()
    const [defaultOpenKeys, setdDefaultOpenKeys] = useState()
    useState([])
    const getISSUE = async () => {
        try {
            await axios.get(
                REQUEST_URL + '/index/getIssue',
            ).then((Response) => {
                setIssueItem(Response.data.data)
                if (Response.data.data.length > 0) {
                    console.log(Response.data.data)
                    if (urlYear === null || urlIssue === null) {
                        getIssueArticle(Response.data.data[0].children[0].key)
                        setDefaultSelectedKeys(Response.data.data[0].children[0].key)
                        setdDefaultOpenKeys(Response.data.data[0].key)
                    } else {
                        // getIssueArticle(Response.data.data[0].children[0].key)
                        // setDefaultSelectedKeys(Response.data.data[0].children[0].key)

                        // console.log(Response.data.data.filter((item) => (item.key === `${urlYear}`))[0].key)
                        setdDefaultOpenKeys(Response.data.data.filter((item) => (item.key === `${urlYear}`))[0].key)
                        // console.log(Response.data.data.filter((item) => (item.key === `${urlYear}`))[0])
                        console.log(Response.data.data.filter((item) => (item.key === `${urlYear}`))[0].children.filter((item) => (item.issue === `${urlIssue}`))[0].key)
                        setDefaultSelectedKeys(Response.data.data.filter((item) => (item.key === `${urlYear}`))[0].children.filter((item) => (item.issue === `${urlIssue}`))[0].key)
                        getIssueArticle(Response.data.data.filter((item) => (item.key === `${urlYear}`))[0].children.filter((item) => (item.issue === `${urlIssue}`))[0].key)
                    }
                }
            })
        } catch (error) {
            throw new Error(error)
        }
    }


    const getIssueArticle = async (ids) => {
        try {
            await axios.get(
                REQUEST_URL + '/index/getIssueArticle',
                { params: { 'ids': ids } }
            ).then((Response) => {
                setInfoData(Response.data.data)
                setTotal(Response.data.total)
                setIssueInfo(Response.data.issue_info)
            })
        } catch (error) {
            throw new Error(error)
        }
    }


    useEffect(() => {
        getISSUE()
    }, [])



    const onClick = (e) => {
        console.log('click ', e);
        getIssueArticle(e.key)
    };

    const download_pdf = async (ids) => {
        console.log(ids)
        try {
            const { data } = await axios.post(
                REQUEST_URL + '/upload/getPDF',
                {
                    'id': ids,
                }
            )
            window.open(data.data)
        } catch (error) {
            throw new Error(error)
        }
    }

    return (
        <Layout className={style.jckb}>
            <Header className={style.jckb__header}>
                <MyHeaderOne />
            </Header>
            <Content className={style.jckb__wapper}>
                <Flex vertical={true} className={style.jckb__wapper__one} align='center'>
                    <Flex className={style.jckb__wapper__one__title}>科技出版动态监测快报</Flex>
                    <Flex className={style.jckb__wapper__one__info}>持续监测国内外科技期刊出版的发展态势，准确研判世界一流科技期刊的前沿动向</Flex>
                </Flex>
                <Flex vertical={false} align='start' className={style.jckb__wapper__two}>
                    <Flex className={style.jckb__wapper__two__left}>
                        {(defaultSelectedKeys !== undefined) && <Menu
                            onClick={onClick}
                            style={{
                                width: 256, marginTop: 20
                            }}
                            defaultSelectedKeys={[defaultSelectedKeys]}
                            defaultOpenKeys={[defaultOpenKeys]}
                            mode="inline"
                            items={issueItem}
                        />}
                    </Flex>
                    <Flex vertical={true} className={style.jckb__wapper__two__right}>
                        {(issueInfo !== undefined) && <Flex vertical={false} className={style.jckb__wapper__two__right__top}>
                            <Flex className={style.jckb__wapper__two__right__top__img}>
                                <Image src={img} preview={false} />
                            </Flex>
                            <Flex justify='space-between' style={{ width: '800px' }} vertical={true} className={style.jckb__wapper__two__right__top__info}>
                                <Flex justify='space-between' className={style.jckb__wapper__two__right__top__title}>
                                    <Flex>科技出版动态监测快报 · {issueInfo.year}年第{issueInfo.issue}期</Flex>
                                    <Flex>
                                        {(issueInfo.pdf_name) && <Button style={{ width: '60px', height: '25px' }} type='primary' onClick={() => download_pdf(issueInfo.id)}>下载pdf</Button>}
                                        {/* <a href='./' style={{ fontSize: '14px', lineHeight: '16px' }}>下载pdf</a> */}
                                    </Flex>

                                </Flex>
                                <Flex vertical={true} className={style.jckb__wapper__two__right__top__other}>
                                    <Flex vertical={false}>
                                        <Flex className={style.jckb__wapper__two__right__top__other__column}>责任编辑：</Flex>
                                        <Flex className={style.jckb__wapper__two__right__top__other__info}> {issueInfo.name}</Flex>
                                    </Flex>
                                    <Flex vertical={false}>
                                        <Flex vertical={false}>
                                            <Flex className={style.jckb__wapper__two__right__top__other__column}>发布时间：</Flex>
                                            <Flex className={style.jckb__wapper__two__right__top__other__info}>{issueInfo.create_date.replace('-', '年').replace('-', '月') + '日'}</Flex>
                                        </Flex>
                                        <Flex vertical={false}>
                                            <Flex className={style.jckb__wapper__two__right__top__other__column}>出版时间：</Flex>
                                            <Flex className={style.jckb__wapper__two__right__top__other__info}>{issueInfo.pub_date.replace('-', '年').replace('-', '月') + '日'}</Flex>
                                        </Flex>
                                    </Flex>
                                </Flex>
                            </Flex>
                        </Flex>}
                        <Flex vertical={true} className={style.jckb__wapper__two__right__content}>
                            <Flex className={style.jckb__wapper__two__right__content__title}>
                                本期文章（{total}篇）
                            </Flex>

                            {infoData.map((item, index) => {
                                return (
                                    <Flex key={index} vertical={true} className={style.jckb__wapper__two__right__content__item}>
                                        <Flex className={style.jckb__wapper__two__right__content__item__title}><a target='_blank' href={`./detail?show=jckb&id=${item.id}`}>{(index < 9) ? `0${index + 1}` : `${index + 1}`}. {item.title}</a></Flex>
                                        <Flex className={style.jckb__wapper__two__right__content__item__info}>{item.info}</Flex>
                                    </Flex>
                                )
                            })}
                        </Flex>
                    </Flex>
                </Flex>
            </Content>
            <Footer className={style.jckb__footer}>
                <MyFooter />
            </Footer>
        </Layout >
    )
}
